import BaseTooltip from './BaseTooltip.vue';
export { BaseTooltip };
